export class ApiUnreachable extends Error {}
export class ApiError extends Error {}
export class InvalidToken extends Error {}
export class IncompletedRequest extends Error {}
export class ApiTellUser extends Error {}

export class Helper extends Error {
  constructor(errorDetails, ...args) {
    super(...args)
    this.message = errorDetails
  }
}

export const handleError = function (e, info) {
  if (info == null) {
    console.log(e)
  } else {
    console.log(e)
    console.log(info)
  }

  if (e instanceof Helper) {
    return e
  } else {
    return "Something went wrong!"
  }
}
